
import Container from '@/components/container';
import Content from '@/components/content';
import Hero from '@/components/page-specific/buyer-checklist/hero';
import HeaderBack from '@/components/page-specific/buyer-checklist/header-back';
import Print from '@/components/page-specific/buyer-checklist/print';
import Section from '@/components/page-specific/buyer-checklist/section';
import LinkWithImage from '@/components/page-specific/buyer-checklist/link-with-image';
import BlogBox from '@/components/page-specific/buyer-checklist/blog-box';
import Article from '@/components/page-specific/buyer-checklist/article';
import Icon from '@/ui-kit/components/icon';
import { StyleSizeType, StyleColorSchemeType, StyleFontWeightType } from '@/ui-kit/styles/enums';
import { IconType } from '@/ui-kit/components/icon/enums';
import { loadPageData } from '@/utils/prismic';
import routes from '@/constants/routes';
import headMeta from '@/constants/headMeta';
import UserSelectionStoreName from '@/store/user-selection/name';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';

const schema = {
  meta: {
    type: 'Object',
    title: {
      type: 'String',
      default: '',
    },
    description: {
      type: 'String',
      default: '',
    },
  },
  hero: {
    type: 'Object',
    image: {
      type: 'Object',
      subtype: 'image',
    },
    title: {
      type: 'String',
      default: '',
    },
    text: {
      type: 'String',
      default: '',
    },
    toggle: {
      type: 'String',
      default: 'Use the toggle to view the checklist tailored to your location',
    },
  },
  title: {
    type: 'String',
    default: '',
  },
  sub: {
    type: 'Object',
    text: {
      type: 'String',
      default: '',
    },
    color: {
      type: 'String',
      default: '#009FD4',
    },
  },
  text: {
    type: 'String',
    default: '',
  },
  back: {
    type: 'Object',
    show: {
      type: 'Boolean',
      default: false,
    },
    title: {
      type: 'String',
      default: '',
    },
  },
  print: {
    type: 'Boolean',
    default: false,
  },
  body: {
    type: 'Array',
    required: true,
  },
};

export default {
  name: 'BuyerChecklistPage',
  components: {
    Icon,
    Container,
    Content,
    Hero,
    Print,
    HeaderBack,
    Section,
    BlogBox,
    Article,
    LinkWithImage,
    Typography,
  },
  asyncData({ route }) {
    return loadPageData({ schema }, () => routes.buyerChecklist, () => route.params.page);
  },
  data() {
    return {
      baseUrl: routes.buyerChecklist,
      urls: [
        {
          title: 'Do Your Research',
          main_url: 'getting-ready',
          sub_urls: [
            'getting-ready',
            'budget',
          ],
        },
        {
          title: 'Start Your Search',
          main_url: 'start-your-search',
          sub_urls: [
            'start-your-search',
            'find-your-next-home',
            'book-viewings',
            'questions',
            'second-viewings',
          ],
        },
        {
          title: 'Make An Offer',
          main_url: 'make-an-offer',
          sub_urls: [
            'make-an-offer',
            'home-offer',
          ],
        },
        {
          title: 'Closing',
          main_url: 'closing',
          sub_urls: [
            'closing',
            'packing-moving',
          ],
        },
        {
          title: 'Possession',
          main_url: 'possession',
          sub_urls: [
            'possession',
          ],
        },
      ],
      IconType,
      StyleSizeType,
      StyleColorSchemeType,
      StyleFontWeightType,
      TypographyType,
    };
  },
  head() {
    return {
      title: this.meta.title,
      meta: [
        { hid: 'description', name: 'description', content: this.meta.description },
        { property: 'og:title', content: this.meta.title },
        { property: 'og:description', content: this.meta.description },
        { property: 'og:url', content: `${headMeta.domain}${routes.buyerChecklist}` },
        { property: 'og:site_name', content: headMeta.siteName },
        { property: 'og:type', content: headMeta.type },
        { property: 'og:image', content: this.hero?.image?.url },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.state.user.userData;
    },
    currentProvince() {
      return this.$store.state[UserSelectionStoreName].currentProvince;
    },
  },
  methods: {
    getIsUrlVisible(url) {
      return url.sub_urls.includes(this.$route.params.page);
    },
  },
};
